import styled from 'styled-components';

export const SkeletonBox = styled.span`
  display: ${(props) => (props.flex ? 'flex' : 'inline-block')};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  position: relative;
  overflow: hidden;
  background-color: #dddbdd;
  border-radius: ${(props) => props.radius};

  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: skeleton 2s infinite;
    content: '';
  }

  @keyframes skeleton {
    100% {
      transform: translateX(100%);
    }
  }
  @media (min-width: 768px) {
    height: ${(props) => props.desktopHeight || props.height};
    width: ${(props) => props.desktopWidth || props.width};
  }
`;
